import React from 'react';
import { openDialog } from '@/features/dialog/dialogSlice';
import { Typography } from '@mui/material';
import { useDispatch } from 'react-redux';

const DataGridContactName = ({ row, objectType }) => {
	const dispatch = useDispatch();
	const fileMigrationInProgress = row.fileMigrationInProgress;

	const toggleMenuDrawerContact = (event) => {
		event.stopPropagation();
		dispatch(
			openDialog({
				dialogName: 'editContact',
				data: {
					clientId: row.clientId,
				},
			}),
		);
	};

	return (
		<Typography
			{...(objectType === 'client' && {
				...(!fileMigrationInProgress && {
					onClick: toggleMenuDrawerContact,
					className: 'has-link',
				}),
				sx: (theme) => ({
					cursor: fileMigrationInProgress ? null : 'pointer',
					'&:hover': {
						color: theme.palette.primary.main,
					},
				}),
			})}
		>
			{row.contactName}
		</Typography>
	);
};

export default DataGridContactName;
